import { Record, Union } from "./fable_modules/fable-library.4.10.0/Types.js";
import { QuizStatus, Infra_urlForMediaImgSafe, RESP$1_$reflection, RegModels_QuizRecord_$reflection } from "../shared/Shared.fs.js";
import { getRecordField, getUnionFields, isUnion, obj_type, getRecordElements, name, record_type, option_type, union_type, string_type, class_type } from "./fable_modules/fable-library.4.10.0/Reflection.js";
import { empty, FSharpMap__Remove, FSharpMap__Add } from "./fable_modules/fable-library.4.10.0/Map.js";
import { newGuid } from "./fable_modules/fable-library.4.10.0/Guid.js";
import { splitByLines, noCmd, apiCmd } from "./Common.fs.js";
import { equals, comparePrimitives } from "./fable_modules/fable-library.4.10.0/Util.js";
import { tryFind } from "./fable_modules/fable-library.4.10.0/Array.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.4.10.0/Choice.js";
import * as react from "react";
import { singleton, append, map, empty as empty_1, delay, toList } from "./fable_modules/fable-library.4.10.0/Seq.js";
import { HTMLAttr } from "./fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "./fable_modules/fable-library.4.10.0/MapUtil.js";
import { footerHero } from "./MainTemplates.fs.js";
import { toString } from "./fable_modules/fable-library.4.10.0/Date.js";
import { ofArray } from "./fable_modules/fable-library.4.10.0/List.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GetRecordRsp", "Exn", "DeleteError"];
    }
}

export function Msg_$reflection() {
    return union_type("Reg.Msg", [], Msg, () => [[["Item", RESP$1_$reflection(RegModels_QuizRecord_$reflection())]], [["Item", class_type("System.Exception")]], [["Item", string_type]]]);
}

export class Model extends Record {
    constructor(Quiz, Errors) {
        super();
        this.Quiz = Quiz;
        this.Errors = Errors;
    }
}

export function Model_$reflection() {
    return record_type("Reg.Model", [], Model, () => [["Quiz", option_type(RegModels_QuizRecord_$reflection())], ["Errors", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])]]);
}

export function addError(txt, model) {
    let copyOfStruct;
    return new Model(model.Quiz, FSharpMap__Add(model.Errors, (copyOfStruct = newGuid(), copyOfStruct), txt));
}

export function delError(id, model) {
    return new Model(model.Quiz, FSharpMap__Remove(model.Errors, id));
}

export function init(api) {
    return apiCmd(api.getRecord, void 0, (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(1, [Item_1])), new Model(void 0, empty({
        Compare: comparePrimitives,
    })));
}

export function update(api, msg, cm) {
    let matchResult, res_2, id, txt_2, ex;
    switch (msg.tag) {
        case 2: {
            matchResult = 1;
            id = msg.fields[0];
            break;
        }
        case 1: {
            let activePatternResult;
            const msg_1 = msg;
            const pi_1 = tryFind((pi) => (name(pi) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
            if (pi_1 == null) {
                activePatternResult = void 0;
            }
            else {
                const pi$0027 = pi_1;
                let msgType;
                let copyOfStruct = msg_1;
                msgType = Msg_$reflection();
                if (isUnion(msgType)) {
                    const objArray = getUnionFields(msg_1, msgType)[1];
                    if (objArray.length === 1) {
                        try {
                            const patternInput_1 = getUnionFields(getRecordField(objArray[0], pi$0027), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                            activePatternResult = ((name(patternInput_1[0]) === "Error") ? patternInput_1[1][0] : void 0);
                        }
                        catch (matchValue) {
                            activePatternResult = void 0;
                        }
                    }
                    else {
                        activePatternResult = void 0;
                    }
                }
                else {
                    activePatternResult = void 0;
                }
            }
            if (activePatternResult != null) {
                matchResult = 2;
                txt_2 = activePatternResult;
            }
            else {
                matchResult = 3;
                ex = msg.fields[0];
            }
            break;
        }
        default:
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 0;
                res_2 = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult_1;
                const msg_2 = msg;
                const pi_1_1 = tryFind((pi_2) => (name(pi_2) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_1 == null) {
                    activePatternResult_1 = void 0;
                }
                else {
                    const pi$0027_1 = pi_1_1;
                    let msgType_1;
                    let copyOfStruct_1 = msg_2;
                    msgType_1 = Msg_$reflection();
                    if (isUnion(msgType_1)) {
                        const objArray_2 = getUnionFields(msg_2, msgType_1)[1];
                        if (objArray_2.length === 1) {
                            try {
                                const patternInput_1_1 = getUnionFields(getRecordField(objArray_2[0], pi$0027_1), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_1 = ((name(patternInput_1_1[0]) === "Error") ? patternInput_1_1[1][0] : void 0);
                            }
                            catch (matchValue_1) {
                                activePatternResult_1 = void 0;
                            }
                        }
                        else {
                            activePatternResult_1 = void 0;
                        }
                    }
                    else {
                        activePatternResult_1 = void 0;
                    }
                }
                if (activePatternResult_1 != null) {
                    matchResult = 2;
                    txt_2 = activePatternResult_1;
                }
                else {
                    matchResult = 4;
                }
            }
    }
    switch (matchResult) {
        case 0:
            return noCmd(new Model(res_2, cm.Errors));
        case 1:
            return noCmd(delError(id, cm));
        case 2:
            return noCmd(addError(txt_2, cm));
        case 3:
            return noCmd(addError(ex.message, cm));
        default:
            return noCmd(cm);
    }
}

export function view(dispatch, settings, model, l10n) {
    let children_10, children_8, children_2, children_4, props_6, children_18, children_16;
    const children_20 = [(children_10 = [(children_8 = [(children_2 = [react.createElement("div", {
        className: "navbar-brand",
    })], react.createElement("nav", {
        className: "navbar is-transparent is-spaced",
        role: "navigation",
        "aria-label": "dropdown navigation",
    }, ...children_2)), (children_4 = toList(delay(() => {
        const matchValue = model.Quiz;
        if (matchValue == null) {
            return empty_1();
        }
        else {
            return quizView(dispatch, settings, matchValue, l10n);
        }
    })), react.createElement("div", {}, ...children_4)), (props_6 = [new HTMLAttr(94, ["/api/login"]), new HTMLAttr(65, ["button thickbox"]), ["style", {
        margin: "5px",
    }], new HTMLAttr(157, ["_self"])], react.createElement("a", keyValueList(props_6, 1), l10n.Procceed))], react.createElement("div", {
        className: "container has-text-centered",
    }, ...children_8))], react.createElement("div", {
        className: "hero-head",
    }, ...children_10)), (children_18 = [(children_16 = toList(delay(() => map((error) => {
        const children_14 = [react.createElement("button", {
            className: "delete",
            onClick: (_arg) => {
                dispatch(new Msg(2, [error[0]]));
            },
        }), error[1]];
        return react.createElement("div", {
            className: "notification is-danger",
        }, ...children_14);
    }, model.Errors))), react.createElement("div", {
        className: "container",
    }, ...children_16))], react.createElement("div", {
        className: "hero-body",
    }, ...children_18)), footerHero];
    return react.createElement("section", {
        className: "hero is-shadowless is-fullheight",
    }, ...children_20);
}

export function quizView(dispatch, settings, quiz, l10n) {
    let props_4, children, props_2, children_12;
    return ofArray([react.createElement("br", {}), (props_4 = [new HTMLAttr(65, ["image is-128x128"]), ["style", {
        display: "inline-block",
    }]], (children = [(props_2 = [new HTMLAttr(149, [Infra_urlForMediaImgSafe(settings.MediaHost, quiz.ImgKey)])], react.createElement("img", keyValueList(props_2, 1)))], react.createElement("figure", keyValueList(props_4, 1), ...children))), react.createElement("br", {}), react.createElement("h3", {
        className: "title is-3",
    }, quiz.Name), (children_12 = toList(delay(() => {
        let children_6;
        return append(singleton((children_6 = toList(delay(() => {
            let matchValue;
            return append((matchValue = quiz.StartTime, (matchValue == null) ? singleton("???") : singleton(toString(matchValue, "yyyy-MM-dd HH:mm"))), delay(() => append(equals(quiz.Status, new QuizStatus(1, [])) ? append(singleton(" "), delay(() => singleton(react.createElement("span", {
                className: "tag is-danger is-light",
            }, "live")))) : empty_1(), delay(() => singleton(react.createElement("br", {}))))));
        })), react.createElement("p", {
            className: "subtitle is-5",
        }, ...children_6))), delay(() => {
            let children_8;
            return append(singleton((children_8 = splitByLines(quiz.Description), react.createElement("p", {}, ...children_8))), delay(() => ((quiz.EventPage !== "") ? singleton(react.createElement("a", {
                href: quiz.EventPage,
            }, l10n.Details)) : empty_1())));
        }));
    })), react.createElement("div", {
        className: "notification is-white",
    }, ...children_12))]);
}

